import {
  InventoryReducers,
  InventoryStore,
  InventoryStoreProviderProps,
} from '@/hooks/inventory/types'
import { useMemo } from 'react'
import { createContext } from 'use-context-selector'
import { filtersDefault } from './reducers/filters'
import { idealPortfolioDefault } from './reducers/idealPortfolio'
import { inventoryDefault } from './reducers/inventory'
import { pageDefault } from './reducers/page'
import { productDefault } from './reducers/product'
import combinedReducers from './reducers'

const noopDispatch = () => undefined

export const StateContext = createContext<InventoryStore>({
  store: {
    filtersStore: filtersDefault,
    pageStore: pageDefault,
    inventoryStore: inventoryDefault,
    productStore: productDefault,
    idealPortfolioStore: idealPortfolioDefault,
  },
})
export const UpdaterContext = createContext<InventoryReducers>({
  reducers: {
    filtersDispatch: noopDispatch,
    pageDispatch: noopDispatch,
    inventoryDispatch: noopDispatch,
    productDispatch: noopDispatch,
    idealPortfolioDispatch: noopDispatch,
  },
})

const InventoryStoreProvider = ({
  children,
  initialValue = {},
}: InventoryStoreProviderProps) => {
  const { store, reducers } = combinedReducers(initialValue)
  const stateValue = useMemo(() => ({ store }), [store])
  const updaterValue = useMemo(() => ({ reducers }), [reducers])

  return (
    <StateContext.Provider value={stateValue}>
      <UpdaterContext.Provider value={updaterValue}>
        {children}
      </UpdaterContext.Provider>
    </StateContext.Provider>
  )
}

export default InventoryStoreProvider
